import { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'
import { DataTableColumnHeader } from '@/components/shared/data-table/data-table-column-header'
import { useNavigate } from 'react-router-dom'
import { ProductFeature } from '../types'

export const columns: ColumnDef<ProductFeature>[] = [
  {
    accessorKey: 'id',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Id" />
    ),
    size: 10,
    maxSize: 10,
  },
  {
    accessorKey: 'photo',
    id: 'photo',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Photo" />
    ),
    cell: ({ row }) => {
      const photo = row.getValue('photo') as ProductFeature['photo']
      return (
        <div className="flex w-[60px] items-center">
          {photo ? (
            <img
              src={photo.src_xs ?? photo.src}
              className="w-10 h-10 object-cover"
            />
          ) : (
            <div className="w-10 h-10 bg-gray-100 rounded border flex items-center justify-center text-xs text-gray-400">
              No Image
            </div>
          )}
        </div>
      )
    },
    enableSorting: false,
  },
  {
    accessorFn: row => row.product_feature_profiles[0]?.name,
    id: 'name',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => {
      return (
        <div className="flex space-x-2">
          <span className="max-w-[500px] truncate font-medium">
            {row.getValue('name')}
          </span>
        </div>
      )
    },
  },
  {
    accessorFn: row => row.product_feature_profiles[0]?.description,
    id: 'description',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Description" />
    ),
    cell: ({ row }) => {
      const description = row.getValue('description') as string
      return (
        <div className="flex space-x-2">
          <span className="max-w-[300px] truncate text-sm text-gray-600">
            {description || 'No description'}
          </span>
        </div>
      )
    },
    enableSorting: false,
  },
  {
    accessorFn: row => row.product_containers.length,
    id: 'products_count',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Products" />
    ),
    cell: ({ row }) => {
      const count = row.getValue('products_count') as number
      const navigate = useNavigate()

      const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation() // Prevent row click event from firing
        const featureId = row.original.id
        navigate(`/products?features=${featureId}`)
      }

      return (
        <div className="flex w-[100px] items-center">
          <Badge
            variant="secondary"
            className="rounded-sm cursor-pointer hover:underline"
            onClick={handleClick}
          >
            {count} product{count !== 1 ? 's' : ''}
          </Badge>
        </div>
      )
    },
  },
]
